import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconAspectRatio219"><Path d="M23.5 6.5H0.5V17.5H23.5V6.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio219;
